import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { onValue, ref } from 'firebase/database'

import { db, tref } from '../lib/firebase.js'
import CLUB from '../config/club.js'

// Short-link resolver for /live (and live.pbccgolf.com). Finds the currently-
// live event and forwards to the existing follow-live hub at /hub?t={id}, so one
// link never goes stale. Prefers a REAL (non-demo), non-closed tournament — most
// recent by createdAt, the same rule the TV boards use. If there's no real event
// yet, it FALLS BACK to the most-recent demo/practice (by demoCreatedAt) so /live
// still lands on the current demo. Read-only; nothing operator/admin, no AI circle.
export default function LiveRedirect() {
  const [state, setState] = useState({ loading: true, id: null })

  useEffect(() => {
    const off = onValue(
      tref('tournaments'),
      (snap) => {
        const all = snap.val() || {}
        const open = Object.entries(all).filter(([, v]) => v?.info?.status !== 'closed')

        // 1) Prefer a real (non-demo) open tournament — most recent first.
        const real = open
          .filter(([, v]) => !v?.info?.isDemo)
          .sort((a, b) => (b[1]?.info?.createdAt || 0) - (a[1]?.info?.createdAt || 0))
        if (real[0]) { setState({ loading: false, id: real[0][0] }); return }

        // 2) Fall back to the most-recent demo/practice by demoCreatedAt.
        const demo = open
          .filter(([, v]) => !!v?.info?.isDemo)
          .sort((a, b) =>
            ((b[1]?.info?.demoCreatedAt || b[1]?.info?.createdAt || 0) -
             (a[1]?.info?.demoCreatedAt || a[1]?.info?.createdAt || 0)))
        setState({ loading: false, id: demo[0]?.[0] || null })
      },
      () => setState({ loading: false, id: null }),
    )
    return () => off()
  }, [])

  if (state.loading) {
    return (
      <div
        className="min-h-full flex items-center justify-center"
        style={{ backgroundColor: CLUB.backgroundColor, color: '#FFFFFF' }}>
        <p className="text-lg">Loading…</p>
      </div>
    )
  }

  if (state.id) return <Navigate to={`/hub?t=${state.id}`} replace />

  return (
    <div
      className="min-h-full flex items-center justify-center px-6 text-center"
      style={{ backgroundColor: CLUB.backgroundColor }}>
      <div style={{ color: '#FFFFFF' }}>
        <div className="text-5xl mb-3">⛳</div>
        <p className="text-xl">No live tournament right now — check back soon.</p>
      </div>
    </div>
  )
}
